import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "./axiosInstance"; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [isSubscriptionRequired, setisSubscriptionRequired] = useState(null); 

  useEffect(() => { 
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    if (token && user) {
      verifyToken(token);
    } else {
      setIsLoggedIn(false);
      setIsLoggedOut(true);
      setUserRole(null);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      const response = await axiosInstance.post("/api/login/verifyToken", {
        token,
      });
      if (response.status === 200) { 

        setIsLoggedIn(true);
        setIsLoggedOut(false); 
      } else {
        logout();
      }
    } catch (error) {
      console.error("Token verification failed:", error);
      logout();
    }
  };

  const login = (UserObj) => {
    localStorage.setItem("token", UserObj.token);
    localStorage.setItem("user", JSON.stringify(UserObj.user));
    setIsLoggedIn(true);
    setIsLoggedOut(false);
    checkAccountStatusAndRedirect(UserObj);
  };

  const checkAccountStatusAndRedirect = (UserObj) => {
    if (UserObj.user.accountStatus === "uncompleted") { 
      window.location.href = "/completeAccount";
    }else  {
      window.location.href = "/dashboard";
  }; 
} 


  const loggedUser = JSON.parse(localStorage.getItem("user"));

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    setUserRole(null);
    setIsLoggedOut(true);
    setisSubscriptionRequired(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        isLoggedOut,
        userRole,
        login,
        logout,
        isSubscriptionRequired,
        loggedUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
